import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Badge, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";

import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Col,
    Icon,
    PreviewAltCard,
    Row,
} from "../../components/Component";

import MyButton from "../../MyComp/UI/form/MyButton";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";

import {
    createLabCategory,
    createPromotion,
    deleteLabCategory,
    getLabCategory,
    getPromotionListAPI,
    updateLabCategory,
    updatePromotion,
} from "../../api/master/indes";
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import DateIso from "../../MyComp/UI/form/DateIso";
import useLogout from "../../hooks/useLogout";
import MyDate from "../../MyComp/UI/form/MyDate";
import moment from "moment";
import MySelect from "../../MyComp/UI/form/MySelect";
import { categoryDDAPI } from "../../api/dropdown";
import { CapacityAPI } from "../../api/Hospital";
import { CapacityListAPI } from "../../api/Hospital";

const Promotion = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            categoryDD: [],
        },
    });

    const { logout } = useLogout();

    // Separate table state from form
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [mode, setMode] = useState("Add");
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const columns = [
        {
            name: "Total Beds",
            selector: (row) => row?.total_beds,
            sortable: true,
        },
        {
            name: "ICU Beds",
            selector: (row) => row?.icu_beds,
            sortable: true,
        },
        {
            name: "NICU Beds",
            selector: (row) => row?.nicu_beds,
            sortable: true,
        },
        {
            name: "PICU Beds",
            selector: (row) => row?.picu_beds,
            sortable: true,
        },
        {
            name: "Emergency Beds",
            selector: (row) => row?.emergency_beds,
            sortable: true,
        },
        {
            name: "Private Rooms",
            selector: (row) => row?.private_rooms,
            sortable: true,
        },
        {
            name: "Semi Private Rooms",
            selector: (row) => row?.semi_private_rooms,
            sortable: true,
        },

        // {
        //     name: "Status",
        //     selector: (row) => row?.status,
        //     cell: (row) => (
        //         <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
        //             <Badge
        //                 style={{ width: "57px", display: "flex", justifyContent: "center" }}
        //                 color={row.status ? "success" : "danger"}
        //             >
        //                 {row.status ? "Active" : "Inactive"}
        //             </Badge>
        //         </div>
        //     ),
        //     sortable: true,
        //     width: "90px",
        // },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Button outline color="warning" size="xs" onClick={() => handleEdit(row)}>
                        <Icon name="edit" />
                    </Button>{" "}
                    {/* <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
                        <Icon name="trash" onClick={() => handleDeleteClick(row)} />
                    </Button> */}
                </div>
            ),

            width: "120px",
        },
        // {
        //   name: "Delete",
        //   width: "150px",
        //   cell: (row) => (
        //     <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
        //       <Icon name="trash" onClick={() => handleDeleteClick(row)} />
        //     </Button>
        //   ),
        // },
    ];

    useEffect(() => {
        getCapacityList();
    }, []);

    const getCapacityList = () => {
        setLoading(true);
        CapacityListAPI()
            .then((res) => {
                setLoading(false);
                if (res.data.status === true) {
                    setTableData(res.data.data);
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message);
            });
    };

    const onFormSubmit = (formData) => {
        const body = {
            total_beds: Number(watch("total_beds")),
            icu_beds: Number(watch("icu_beds")),
            nicu_beds: Number(watch("nicu_beds")),
            picu_beds: Number(watch("picu_beds")),
            emergency_beds: Number(watch("emergency_beds")),
            private_rooms: Number(watch("private_rooms")),
            semi_private_rooms: Number(watch("semi_private_rooms")),
        };

        console.log(body, "Capacity Payload");

        setLoading(true);

        CapacityAPI(body)
            .then((res) => {
                setLoading(false);

                if (res.data.status === true) {
                    toast.success(res.data.message);

                    getCapacityList(); // you can rename later (better: getCapacityList)

                    setIsOpen(false);
                    setMode("Add");
                    reset();
                }
                else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                }
                else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message);
            });
    };

    const handleEdit = (row) => {
        window.scrollTo(0, 0);
        setSelectedRow(row);
        setIsOpen(true);
        setMode("Edit");
        // setValue("category", row?.categories);
        setValue("total_beds", row.total_beds);
        setValue("icu_beds", row.icu_beds);
        setValue("nicu_beds", row.nicu_beds);
        setValue("picu_beds", row.picu_beds);
        setValue("emergency_beds", row.emergency_beds);
        setValue("private_rooms", row.private_rooms);
        setValue("semi_private_rooms", row.semi_private_rooms);
    };

    const handleToggleStatus = (row) => {
        console.log(row, "rowtoggle");
        setSelectedRow(row);
        setShowModal(true);
    };

    const confirmStatusChange = () => {
        // Determine the updated status explicitly based on current status
        const updatedStatus = !selectedRow.status;

        // Optionally show loading
        setLoading(true);

        updatePromotion({ id: selectedRow.id, status: updatedStatus })
            .then((res) => {
                setLoading(false);
                if (res.data.status === true) {
                    toast.success(res.data.message);

                    // Update local table only
                    setTableData((prev) =>
                        prev.map((item) =>
                            item.id === selectedRow.id
                                ? { ...item, status: updatedStatus }
                                : item
                        )
                    );

                    setShowModal(false);
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message);
            });
    };

    const handleDeleteClick = (row) => {
        setSelectedRow(row);
        setShowDeleteModal(true);
    };

    const confirmDelete = () => {
        if (!selectedRow) return;

        setLoading(true);

        deleteLabCategory({ id: selectedRow.id })
            .then((res) => {
                setLoading(false);
                setShowDeleteModal(false);
                if (res.data.status === true) {
                    toast.success(res.data.message);
                    setTableData((prev) => prev.filter((item) => item.id !== selectedRow.id));
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message);
            });
    };
    const resetF = () => {
        setValue("status", "");
        setValue("selectedRow", "");
        setMode("Add");
        setValue("discount", "");
        setValue("start_date", null);
        setValue("exp_date", null);
        setValue("type", "");
        setValue("coupon_name", "");
        setValue("code", "");
        setValue("category", "");
        setValue("description", "");
        setValue("min_amount", "");
        setValue("max_discount", "");
    };
    useEffect(() => {
        const a = watch("code");
        setValue("code", a?.toUpperCase())
    }, [watch("code")])
    return (
        <>
            <Head title="Hospital Capacity | Master" />
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                Capacity
                            </BlockTitle>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <Button
                                color="primary"
                                outline
                                className="me-n1"
                                onClick={() => {
                                    if (!isOpen) {
                                        setIsOpen(true);
                                        setMode("Add");
                                        resetF();
                                    } else {
                                        setIsOpen(false);
                                    }
                                }}
                            >
                                <Icon name={isOpen ? "minus" : "plus"} />
                            </Button>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <Block>
                    {isOpen && (
                        <PreviewAltCard>
                            <Form onSubmit={handleSubmit(onFormSubmit)}>
                                <Row>
                                    <Col md="3">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="Total Beds"
                                            name="total_beds"
                                            placeholder="Enter total beds "
                                            required
                                        />
                                    </Col>

                                    <Col md="3">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="ICU Beds"
                                            name="icu_beds"
                                            placeholder="Enter ICU beds "
                                            required
                                        />
                                    </Col>

                                    <Col md="3">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="NICU Beds"
                                            name="nicu_beds"
                                            placeholder="Enter NICU beds "
                                            required
                                        />
                                    </Col>

                                    <Col md="3">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="PICU Beds"
                                            name="picu_beds"
                                            placeholder="Enter PICU beds "
                                            required
                                        />
                                    </Col>

                                    <Col md="3">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="Emergency Beds"
                                            name="emergency_beds"
                                            placeholder="Enter emergency beds "
                                            required
                                        />
                                    </Col>

                                    <Col md="3">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="Private Rooms"
                                            name="private_rooms"
                                            placeholder="Enter private rooms "
                                            required
                                        />
                                    </Col>

                                    <Col md="3">
                                        <MyInput
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title="Semi Private Rooms"
                                            name="semi_private_rooms"
                                            placeholder="Enter semi private rooms "
                                            required
                                        />
                                    </Col>
                                </Row>{" "}
                                <Col md="3">
                                    <MyButton isLoading={loading} mode={mode} />
                                </Col>
                            </Form>
                        </PreviewAltCard>
                    )}

                    <MyDataTable data={tableData} columns={columns} title="Capacity List" isLoading={loading} />
                </Block>
            </Content>

            <DeleteModal
                showDeleteModal={showDeleteModal}
                setShowDeleteModal={setShowDeleteModal}
                confirmDelete={confirmDelete}
                selectedRow={selectedRow}
                loading={loading}
            />

            <ConfirmModal
                isOpen={showModal}
                toggle={() => setShowModal(!showModal)}
                onConfirm={confirmStatusChange}
                status={selectedRow?.status}
            />
        </>
    );
};

export default Promotion;
